import React from 'react';
import theme from '../../theme';
import {Typography} from '@material-ui/core';

interface PrintPreviewAttributionProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    attribution: string;
}

export function PrintPreviewAttribution(props: PrintPreviewAttributionProps) {
    return <div style={{
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        display: 'inline'
    }} {...props}>
        <Typography style={{display: 'inline', fontSize: '6pt', fontWeight: 600}}>
            {props.title}:
        </Typography>
        <Typography style={{
            display: 'inline',
            fontSize: '6pt',
            fontWeight: 400,
            marginLeft: theme.spacing(0.5)
        }}>
            {props.attribution}
        </Typography>
    </div>;
}
